interface Section {
  heading: string;
  paragraphs?: string[];
  list?: string[];
}

const sections: Section[] = [
  {
    heading: "1. はじめに",
    paragraphs: [
      "株式会社ナンバ(以下「当社」といいます)は、当社が提供する人材みえる化ソリューション(以下「本サービス」といいます)および本ウェブサイトの運営において、お客様の個人情報の重要性を深く認識し、個人情報の保護に関する法律(以下「個人情報保護法」といいます)を遵守するとともに、以下のプライバシーポリシー(以下「本ポリシー」といいます)に従い、適切な取扱いと保護に努めます。",
    ],
  },
  {
    heading: "2. 個人情報の定義",
    paragraphs: [
      "本ポリシーにおいて「個人情報」とは、個人情報保護法第2条第1項に定める情報をいい、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日、住所、電話番号、メールアドレスその他の記述等により特定の個人を識別できるもの、および個人識別符号が含まれるものを指します。",
    ],
  },
  {
    heading: "3. 個人情報の収集方法",
    paragraphs: [
      "当社は、お客様がお問い合わせ、資料請求、本サービスへのご登録、アンケート回答などをされた際に、お客様の会社名、氏名、メールアドレス、電話番号、住所などの個人情報をお尋ねすることがあります。",
      "また、当社ウェブサイトの利用状況を把握するために、Cookieやアクセス解析ツールを用いて閲覧情報を収集することがあります。",
    ],
  },
  {
    heading: "4. 個人情報の利用目的",
    paragraphs: ["当社は、収集した個人情報を以下の目的で利用します。"],
    list: [
      "本サービスの提供および運営のため",
      "お問い合わせ・資料請求への対応のため",
      "本サービスの品質向上のためのアンケート実施のため",
      "新サービスやキャンペーンなどのご案内のため",
      "採用応募者への連絡および選考のため",
      "ウェブサイトの利用状況分析および改善のため",
      "法令に基づく対応のため",
    ],
  },
  {
    heading: "5. 個人情報の安全管理措置",
    paragraphs: [
      "当社は、個人情報の漏洩、滅失、または毀損の防止その他の個人情報の安全管理のために、必要かつ適切な措置を講じます。具体的には、以下の措置を実施しています。",
    ],
    list: [
      "個人情報の取扱いに関する社内規程の整備",
      "従業員に対する定期的な教育研修の実施",
      "アクセス権限の適切な管理",
      "外部からの不正アクセス防止のためのセキュリティ対策",
    ],
  },
  {
    heading: "6. 個人情報の第三者提供",
    paragraphs: [
      "当社は、以下のいずれかに該当する場合を除き、あらかじめお客様の同意を得ることなく、個人情報を第三者に提供することはありません。",
    ],
    list: [
      "法令に基づく場合",
      "人の生命、身体または財産の保護のために必要がある場合であって、お客様の同意を得ることが困難であるとき",
      "公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、お客様の同意を得ることが困難であるとき",
      "国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合",
    ],
  },
  {
    heading: "7. Cookie(クッキー)の利用",
    paragraphs: [
      "当社ウェブサイトでは、お客様の利便性向上およびサイト改善のためにCookieを使用しています。Cookieとは、ウェブサーバーからお客様のブラウザに送信され、お客様のデバイスに保存される小さなテキストファイルです。",
      "お客様はブラウザの設定によりCookieの受け入れを拒否することができますが、その場合、当社ウェブサイトの一部の機能がご利用いただけなくなる可能性があります。",
    ],
  },
  {
    heading: "8. アクセス解析ツールについて",
    paragraphs: [
      "当社ウェブサイトでは、お客様のサイト利用状況を分析するためにGoogle Analyticsを利用しています。Google AnalyticsはCookieを使用してトラフィックデータを収集しますが、このデータは匿名で収集されており、個人を特定するものではありません。データ収集および処理の仕組みについては、Google社のプライバシーポリシーをご確認ください。",
    ],
  },
  {
    heading: "9. 個人情報の開示・訂正・利用停止等",
    paragraphs: [
      "当社は、お客様ご本人から個人情報の開示、訂正、追加、削除、利用停止、消去または第三者提供の停止(以下「開示等」といいます)のお申し出があった場合には、ご本人であることを確認した上で、法令に従い合理的な期間内に対応いたします。",
      "開示等のご請求につきましては、下記のお問い合わせ窓口までご連絡ください。",
    ],
  },
  {
    heading: "10. 本ポリシーの変更",
    paragraphs: [
      "当社は、法令の変更や事業上の必要性に応じて、本ポリシーの内容を適宜見直し、改定することがあります。重要な変更がある場合には、当社ウェブサイト上でお知らせいたします。改定後のプライバシーポリシーは、当社ウェブサイトに掲載した時点から効力を生じるものとします。",
    ],
  },
];

const contactInfo = [
  { label: "事業者名", value: "株式会社ナンバ" },
  { label: "代表者", value: "代表取締役 難波 伸敏" },
  { label: "所在地", value: "〒115-0056 東京都北区西が丘2-1-11" },
  { label: "電話番号", value: "03-6454-3314" },
  { label: "メールアドレス", value: "info@namba.ne.jp" },
  { label: "受付時間", value: "平日 9:30〜18:30(土日祝日・年末年始を除く)" },
];

export default function PrivacySections() {
  return (
    <section className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <div className="space-y-10 rounded-lg border border-background-200 bg-background-50 p-6 font-body text-sm leading-relaxed text-foreground-800 md:p-10">
          {sections.map((section) => (
            <div key={section.heading}>
              <h2 className="mb-4 font-heading text-lg font-bold text-foreground-950">
                {section.heading}
              </h2>
              {section.paragraphs?.map((paragraph) => (
                <p key={paragraph} className="mb-3 last:mb-0">
                  {paragraph}
                </p>
              ))}
              {section.list && (
                <ul className="ml-2 mt-3 list-disc space-y-1.5 pl-4">
                  {section.list.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}

          <div>
            <h2 className="mb-4 font-heading text-lg font-bold text-foreground-950">
              11. お問い合わせ窓口
            </h2>
            <p className="mb-4">
              本ポリシーに関するお問い合わせ、および個人情報の開示等のご請求は、以下の窓口までご連絡ください。
            </p>
            <div className="space-y-2 rounded-lg bg-background-100 p-5 text-foreground-700">
              {contactInfo.map((item) => (
                <p key={item.label} className="flex flex-col gap-0.5 sm:flex-row sm:gap-2">
                  <strong className="shrink-0 text-foreground-950 sm:min-w-[7.5rem]">
                    {item.label}:
                  </strong>
                  <span>{item.value}</span>
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}